



































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import messageModule from "@/store/modules/message-module";

// DevExtreme Imports
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxFilterRow,
} from "devextreme-vue/data-grid";

@Component({
  name: "ThreatExplorer",
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow,
  },
})
export default class ThreatExplorer extends Vue {
  public ranking: any[] = [];
  public loadingRanking: boolean = false;
  public profileDialog: boolean = false;
  public selectedIpProfile: any = null;
  public loadingProfile: boolean = false;

  public mounted() {
    this.loadRanking();
  }

  public async loadRanking() {
    this.loadingRanking = true;
    try {
      this.ranking = await ssmHttpService.get(
        API.threatIntelligence + "/ranking?limit=50"
      );
    } catch (error) {
      console.error("Error loading threats ranking:", error);
    } finally {
      this.loadingRanking = false;
    }
  }

  public async viewIpProfile(ip: string) {
    this.loadingProfile = true;
    try {
      this.selectedIpProfile = await ssmHttpService.get(
        API.threatIntelligence + "/profile/" + ip
      );
      this.profileDialog = true;
    } catch (error) {
      console.error("Error loading IP profile:", error);
      messageModule.showAlert({
        title: "Error",
        text: "No se pudo cargar el perfil detallado de la IP.",
        type: "error",
      });
    } finally {
      this.loadingProfile = false;
    }
  }

  public banFromProfile(ip: string) {
    this.$emit("request-ban", ip);
  }

  public getTrustColor(label: string) {
    if (!label) return "grey";
    const l = label.toLowerCase();
    if (l.includes("genuine")) return "success";
    if (l.includes("suspicious")) return "orange";
    if (l.includes("bot")) return "error";
    if (l.includes("attacker")) return "red darken-4";
    return "grey";
  }

  public getScoreColor(score: number) {
    if (score <= 30) return "success";
    if (score <= 60) return "orange";
    if (score <= 85) return "error";
    return "red darken-4";
  }

  public formatBehavior(summary: string) {
    if (!summary) return "";
    try {
      const arr = JSON.parse(summary);
      return arr.length > 0 ? arr[0] : "Sin actividad sospechosa";
    } catch {
      return summary;
    }
  }

  public getEventColor(event: string) {
    const e = event.toLowerCase();
    if (e.includes("emergency") || e.includes("path") || e.includes("probing"))
      return "error";
    if (e.includes("warning") || e.includes("waf") || e.includes("login"))
      return "orange";
    if (e.includes("rate") || e.includes("limit")) return "yellow darken-3";
    return "info";
  }

  public getEventIcon(event: string) {
    const e = event.toLowerCase();
    if (e.includes("path") || e.includes("probing")) return "mdi-folder-search";
    if (e.includes("waf")) return "mdi-shield-bug";
    if (e.includes("login")) return "mdi-account-lock";
    if (e.includes("rate") || e.includes("limit")) return "mdi-speedometer";
    if (e.includes("privilege")) return "mdi-key-alert";
    return "mdi-information";
  }

  public calculateRadarPoints(analysis: any) {
    if (!analysis) return "100,20 185,105 100,195 10,105 160,40"; // Default pentagon
    const centerX = 100;
    const centerY = 100;
    const radius = 80;

    const checks = [
      analysis.path || 20,
      analysis.waf || 20,
      analysis.login || 20,
      analysis.rate || 20,
      analysis.privilege || 20,
    ];

    return checks
      .map((val, i) => {
        const angle = (Math.PI * 2 * i) / 5 - Math.PI / 2;
        const r = (val / 100) * radius;
        const x = centerX + r * Math.cos(angle);
        const y = centerY + r * Math.sin(angle);
        return `${x},${y}`;
      })
      .join(" ");
  }
}
